/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_LiteratureInputs */

const en_homepage_listen_in_literature = /** @type {(inputs: Homepage_Listen_In_LiteratureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Literature Review`)
};

const es_homepage_listen_in_literature = /** @type {(inputs: Homepage_Listen_In_LiteratureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisión literaria`)
};

/**
* | output |
* | --- |
* | "Literature Review" |
*
* @param {Homepage_Listen_In_LiteratureInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_literature = /** @type {((inputs?: Homepage_Listen_In_LiteratureInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_LiteratureInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_literature(inputs)
	return en_homepage_listen_in_literature(inputs)
});